export default __webpack_public_path__ + "static/thehub-md-d8a84394fe12b7eace7cacceaaf8d739.png";